var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchivoListaCard24X24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7198 15.0999C11.7198 14.6857 12.0556 14.3499 12.4698 14.3499H17.0698C17.484 14.3499 17.8198 14.6857 17.8198 15.0999C17.8198 15.5141 17.484 15.8499 17.0698 15.8499H12.4698C12.0556 15.8499 11.7198 15.5141 11.7198 15.0999Z",
    fill: "#2FB699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7198 9.0999C11.7198 8.68569 12.0556 8.3499 12.4698 8.3499H18.4698C18.884 8.3499 19.2198 8.68569 19.2198 9.0999C19.2198 9.51412 18.884 9.8499 18.4698 9.8499H12.4698C12.0556 9.8499 11.7198 9.51412 11.7198 9.0999Z",
    fill: "#2FB699"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97913 7.11859C10.2726 7.41094 10.2734 7.88582 9.98109 8.17925L7.28109 10.8893C7.14053 11.0303 6.94963 11.1097 6.75048 11.1099C6.55133 11.1101 6.36028 11.0311 6.21945 10.8902L4.99946 9.67023C4.70656 9.37734 4.70656 8.90247 4.99945 8.60957C5.29235 8.31668 5.76722 8.31668 6.06011 8.60957L6.7488 9.29826L8.91848 7.12055C9.21083 6.82712 9.6857 6.82624 9.97913 7.11859Z",
    fill: "#2FB699"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97913 13.1086C10.2726 13.4009 10.2734 13.8758 9.98109 14.1693L7.28109 16.8793C7.14053 17.0203 6.94963 17.0997 6.75048 17.0999C6.55133 17.1001 6.36028 17.0211 6.21945 16.8802L4.99946 15.6602C4.70656 15.3673 4.70656 14.8925 4.99946 14.5996C5.29235 14.3067 5.76722 14.3067 6.06012 14.5996L6.7488 15.2883L8.91848 13.1106C9.21083 12.8171 9.6857 12.8162 9.97913 13.1086Z",
    fill: "#2FB699"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56 2.75C4.90351 2.75 2.75 4.90351 2.75 7.56V16.44C2.75 19.0965 4.90351 21.25 7.56 21.25H16.44C19.0965 21.25 21.25 19.0965 21.25 16.44V7.56C21.25 4.90351 19.0965 2.75 16.44 2.75H7.56ZM1.25 7.56C1.25 4.07508 4.07508 1.25 7.56 1.25H16.44C19.9249 1.25 22.75 4.07508 22.75 7.56V16.44C22.75 19.9249 19.9249 22.75 16.44 22.75H7.56C4.07508 22.75 1.25 19.9249 1.25 16.44V7.56Z",
    fill: "#2FB699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchivoListaCard24X24);
export default __webpack_public_path__ + "static/media/ACHIVO_LISTA_CARD_24X24.5c4f426bc543a520ec8864a4f733d681.svg";
export { ForwardRef as ReactComponent };